(() => {
  const norm = (value) => {
    const code = (value || "").trim().toLowerCase();
    if (code === "es" || code.startsWith("es-")) return "es";
    if (code === "zh-cn" || code === "zh-hans" || code === "zh" || code.startsWith("zh-hans")) return "zh-CN";
    if (code === "zh-tw" || code === "zh-hant" || code.startsWith("zh-hant")) return "zh-TW";
    if (code === "en" || code.startsWith("en-")) return "en";
    return "";
  };

  const clean = (value) => (value || "").replace(/\s+/g, " ").trim();
  const params = new URLSearchParams(window.location.search);
  const language = norm(params.get("site_lang")) || norm(localStorage.getItem("medicalTravelLanguage")) || "en";

  const labels = {
    "zh-CN": {
      "specialty-dental": "\u7259\u79d1",
      "specialty-orthopedics": "\u9aa8\u79d1\u670d\u52a1",
      "specialty-health-checkup": "\u4f53\u68c0",
      "specialty-oncology": "\u80bf\u7624",
      "specialty-cardiology": "\u5fc3\u810f\u4e0e\u8840\u7ba1",
      "specialty-neurology": "\u795e\u7ecf\u5185\u5916\u79d1",
      "specialty-digestive-liver": "\u6d88\u5316\u4e0e\u809d\u80c6\u75be\u75c5",
      "specialty-ophthalmology": "\u773c\u79d1",
      "specialty-fertility-womens-health": "\u751f\u6b96\u4e0e\u5973\u6027\u5065\u5eb7",
      "specialty-rehabilitation-tcm": "\u5eb7\u590d\u4e0e\u4e2d\u533b\u7ed3\u5408",
      "specialty-dermatology-aesthetics": "\u76ae\u80a4\u79d1\u4e0e\u533b\u5b66\u7f8e\u5bb9",
      "specialty-complex-conditions": "\u7f55\u89c1\u75c5\u4e0e\u590d\u6742\u75c5\u60c5"
    },
    "zh-TW": {
      "specialty-dental": "\u7259\u79d1",
      "specialty-orthopedics": "\u9aa8\u79d1\u670d\u52d9",
      "specialty-health-checkup": "\u5065\u5eb7\u6aa2\u67e5",
      "specialty-oncology": "\u816b\u7624",
      "specialty-cardiology": "\u5fc3\u81df\u8207\u8840\u7ba1",
      "specialty-neurology": "\u795e\u7d93\u5167\u5916\u79d1",
      "specialty-digestive-liver": "\u6d88\u5316\u8207\u809d\u81bd\u75be\u75c5",
      "specialty-ophthalmology": "\u773c\u79d1",
      "specialty-fertility-womens-health": "\u751f\u6b96\u8207\u5973\u6027\u5065\u5eb7",
      "specialty-rehabilitation-tcm": "\u5eb7\u5fa9\u8207\u4e2d\u91ab\u7d50\u5408",
      "specialty-dermatology-aesthetics": "\u76ae\u819a\u79d1\u8207\u91ab\u5b78\u7f8e\u5bb9",
      "specialty-complex-conditions": "\u7f55\u898b\u75c5\u8207\u8907\u96dc\u75c5\u60c5"
    },
    es: {
      "specialty-dental": "Dental",
      "specialty-orthopedics": "Ortopedia",
      "specialty-health-checkup": "Chequeo medico",
      "specialty-oncology": "Oncologia",
      "specialty-cardiology": "Cardiologia",
      "specialty-neurology": "Neurologia / Neurocirugia",
      "specialty-digestive-liver": "Digestivo e higado",
      "specialty-ophthalmology": "Oftalmologia",
      "specialty-fertility-womens-health": "Fertilidad y salud femenina",
      "specialty-rehabilitation-tcm": "Rehabilitacion y medicina china",
      "specialty-dermatology-aesthetics": "Dermatologia y estetica medica",
      "specialty-complex-conditions": "Casos raros o complejos"
    }
  };

  const phrases = {
    "zh-CN": {
      "Cardiology": "\u5fc3\u810f\u4e0e\u8840\u7ba1",
      "Cardiology / Heart Health": "\u5fc3\u810f\u4e0e\u8840\u7ba1",
      "Preventive Risk": "\u9884\u9632\u6027\u98ce\u9669\u8bc4\u4f30",
      "Symptoms & Abnormal Tests": "\u75c7\u72b6\u4e0e\u5f02\u5e38\u68c0\u67e5",
      "Travel Support": "\u884c\u7a0b\u652f\u6301",
      "Send your heart-related reports and symptoms first.": "\u8bf7\u5148\u53d1\u9001\u60a8\u7684\u5fc3\u810f\u76f8\u5173\u62a5\u544a\u548c\u75c7\u72b6\u3002",
      "We review whether the inquiry can move forward before you pay for translation, evaluation, travel, or coordination.": "\u5728\u60a8\u652f\u4ed8\u7ffb\u8bd1\u3001\u8bc4\u4f30\u3001\u65c5\u884c\u6216\u534f\u8c03\u8d39\u7528\u524d\uff0c\u6211\u4eec\u4f1a\u5148\u5224\u65ad\u662f\u5426\u9002\u5408\u7ee7\u7eed\u63a8\u8fdb\u3002",
      "Request Cardiology Review First": "\u5148\u7533\u8bf7\u5fc3\u810f\u8bc4\u4f30",
      "Pay Securely After Written Quote": "\u6536\u5230\u4e66\u9762\u62a5\u4ef7\u540e\u5b89\u5168\u4ed8\u6b3e",
      "Some patients need only medical coordination. Others need airport pickup, hotel, translation, family support, and private sightseeing after appointments. The plan is built around your health, mobility, budget, and travel preference.": "\u60a8\u53ef\u4ee5\u53ea\u9700\u8981\u533b\u7597\u534f\u8c03\uff0c\u4e5f\u53ef\u4ee5\u589e\u52a0\u673a\u573a\u63a5\u9001\u3001\u9152\u5e97\u3001\u7ffb\u8bd1\u3001\u5bb6\u5c5e\u652f\u6301\uff0c\u4ee5\u53ca\u5c31\u8bca\u540e\u7684\u79c1\u4eba\u65c5\u6e38\u3002\u65b9\u6848\u4f1a\u56f4\u7ed5\u60a8\u7684\u5065\u5eb7\u72b6\u51b5\u3001\u884c\u52a8\u80fd\u529b\u3001\u9884\u7b97\u548c\u65c5\u884c\u504f\u597d\u6765\u8bbe\u8ba1\u3002",
      "789Medical Travel is built for patients who want to understand whether China is a realistic option before they spend money on flights, hotels, procedures, or paid coordination. You tell us your diagnosis, symptoms, records, timing, and comfort needs; we help shape a route that can be reviewed by an appropriate hospital or department.": "789Medical Travel \u9002\u5408\u5e0c\u671b\u5728\u8d2d\u4e70\u673a\u7968\u3001\u9152\u5e97\u3001\u6cbb\u7597\u6216\u4ed8\u8d39\u534f\u8c03\u524d\uff0c\u5148\u5224\u65ad\u4e2d\u56fd\u662f\u5426\u73b0\u5b9e\u53ef\u884c\u7684\u60a8\u3002\u60a8\u544a\u8bc9\u6211\u4eec\u8bca\u65ad\u3001\u75c7\u72b6\u3001\u75c5\u5386\u3001\u65f6\u95f4\u548c\u8212\u9002\u5ea6\u9700\u6c42\uff0c\u6211\u4eec\u5e2e\u60a8\u6574\u7406\u51fa\u53ef\u63d0\u4ea4\u7ed9\u5408\u9002\u533b\u9662\u6216\u79d1\u5ba4\u8bc4\u4f30\u7684\u8def\u5f84\u3002"
    },
    "zh-TW": {
      "Cardiology": "\u5fc3\u81df\u8207\u8840\u7ba1",
      "Cardiology / Heart Health": "\u5fc3\u81df\u8207\u8840\u7ba1",
      "Preventive Risk": "\u9810\u9632\u6027\u98a8\u96aa\u8a55\u4f30",
      "Symptoms & Abnormal Tests": "\u75c7\u72c0\u8207\u7570\u5e38\u6aa2\u67e5",
      "Travel Support": "\u884c\u7a0b\u652f\u63f4",
      "Send your heart-related reports and symptoms first.": "\u8acb\u5148\u767c\u9001\u60a8\u7684\u5fc3\u81df\u76f8\u95dc\u5831\u544a\u548c\u75c7\u72c0\u3002",
      "Request Cardiology Review First": "\u5148\u7533\u8acb\u5fc3\u81df\u8a55\u4f30",
      "Pay Securely After Written Quote": "\u6536\u5230\u66f8\u9762\u5831\u50f9\u5f8c\u5b89\u5168\u4ed8\u6b3e"
    },
    es: {
      "Cardiology": "Cardiologia",
      "Cardiology / Heart Health": "Cardiologia",
      "Preventive Risk": "Riesgo preventivo",
      "Symptoms & Abnormal Tests": "Sintomas y pruebas anormales",
      "Travel Support": "Apoyo de viaje",
      "Send your heart-related reports and symptoms first.": "Envienos primero sus informes cardiacos y sintomas.",
      "Request Cardiology Review First": "Solicitar primero revision cardiologica",
      "Pay Securely After Written Quote": "Pagar seguro tras cotizacion escrita"
    }
  };

  const patchText = () => {
    if (language === "en") return;
    const map = phrases[language] || {};
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "OPTION"].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return map[clean(node.nodeValue)] ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const key = clean(node.nodeValue);
      node.nodeValue = node.nodeValue.replace(key, map[key]);
    });
  };

  const patchSpecialtyTitles = () => {
    if (language === "en") return;
    const map = labels[language] || {};
    document.querySelectorAll(".preview-card").forEach((card) => {
      const img = card.querySelector("img");
      const title = card.querySelector("strong");
      if (!img || !title) return;
      const src = img.getAttribute("src") || "";
      const key = Object.keys(map).find((item) => src.includes(item));
      if (key) title.textContent = map[key];
    });
  };

  const bindLanguageLinks = () => {
    document.querySelectorAll("[data-language-link]").forEach((link) => {
      code = norm(link.getAttribute("data-locale-code"));
      link.classList.toggle("active", code === language);
      link.setAttribute("aria-current", code === language ? "true" : "false");
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const nextLanguage = norm(link.getAttribute("data-locale-code")) || "en";
        localStorage.setItem("medicalTravelLanguage", nextLanguage);
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("site_lang", nextLanguage);
        window.location.href = nextUrl.toString();
      });
    });
  };

  const run = () => {
    bindLanguageLinks();
    patchText();
    patchSpecialtyTitles();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  setTimeout(run, 250);
  setTimeout(run, 1000);
})();
